export interface ProductEntry {
  slug: string;
  name: string;
  platform: string;
  description: string;
}

export const products: ProductEntry[] = [
  {
    slug: 'stickie',
    name: 'Stickie',
    platform: 'Android',
    description: 'Turn screen captures into stickers you can save and reuse.'
  }
];
